'use client';
import { useState, useCallback } from 'react';

function useSetState(initialState) {
  const [state, _setState] = useState(initialState);
  const setState = useCallback(
    (statePartial) => _setState((current) => ({
      ...current,
      ...typeof statePartial === "function" ? statePartial(current) : statePartial
    })),
    []
  );
  return [state, setState];
}

export { useSetState };
//# sourceMappingURL=use-set-state.mjs.map
